import styled from 'styled-components';

export const Title = styled.div`
  // font-size: calc(14px + (16.8 - 16) * ((100vw - 320px) / (412 - 320)));
  font-size: 2rem;
  color: #fff;
  text-align: left;
`;

export const MainWrapper = styled.div`
  margin-top: 10px;

  .face_bubble_text {
    color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Steps/Likes/components/styles.js